<template>
  <p v-if="compact" class="tag-settings-provenance">
    <span>{{ tag.created_by?.name ? `Created by ${tag.created_by.name}` : 'Author not recorded' }}</span>
    <span v-if="tag.created_at">Created {{ formatDateTimeShort(tag.created_at) }}</span>
    <span v-if="tag.updated_at && formatDateTimeShort(tag.updated_at) !== formatDateTimeShort(tag.created_at)">Updated {{ formatDateTimeShort(tag.updated_at) }}</span>
  </p>
  <dl v-else class="tag-settings-summary" aria-label="Saved tag settings">
    <div><dt>Created by</dt><dd>{{ tag.created_by?.name || 'Author not recorded' }}</dd></div>
    <div><dt>Created</dt><dd>{{ tag.created_at ? formatDateTimeShort(tag.created_at) : 'Date not recorded' }}</dd></div>
    <div><dt>Visible to</dt><dd>{{ tagAudienceLabel(tag,roles) }}</dd></div>
    <div><dt>Used for</dt><dd>{{ {both:'Candidates and employees',candidate:'Candidates',employee:'Employees'}[tag.applies_to] }}</dd></div>
    <div><dt>Keep after hiring</dt><dd>{{ tag.transfer_on_hire ? 'Yes · copied to the employee profile' : 'No' }}</dd></div>
    <div><dt>Status</dt><dd>{{ tag.is_active ? 'Active' : 'Archived · hidden from profiles and tables' }}</dd></div>
    <div><dt>Color</dt><dd><span class="tag-settings-summary__color" :style="{backgroundColor:tag.color}" aria-hidden="true" />{{ tag.color }}</dd></div>
    <div v-if="tag.updated_at"><dt>Last updated</dt><dd>{{ formatDateTimeShort(tag.updated_at) }}</dd></div>
  </dl>
</template>
<script setup>
import { formatDateTimeShort } from '@/utils/common';
import { tagAudienceLabel } from '../utils/peopleTagUtils';
defineProps({compact:Boolean,tag:{type:Object,required:true},roles:{type:Array,default:()=>[]}});
</script>
<style scoped>
.tag-settings-provenance {display:flex;flex-wrap:wrap;gap:4px 12px;margin:0 0 16px;font-size:12px;line-height:1.5;color:var(--crc-text-muted);}

.tag-settings-summary { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:14px 24px; padding:16px; margin:0 0 20px; border:1px solid var(--crc-panel-border,var(--surface-border)); border-radius:10px; background:var(--crc-content-bg); }
.tag-settings-summary dt { font-size:11px; color:var(--crc-text-muted); margin-bottom:5px; }
.tag-settings-summary dd { display:flex; align-items:center; gap:7px; margin:0; font-size:12px; line-height:1.5; overflow-wrap:anywhere; }
.tag-settings-summary__color { width:12px; height:12px; border-radius:4px; border:1px solid #8886; flex-shrink:0; }
@media(max-width:520px) { .tag-settings-summary { grid-template-columns:1fr; } }
</style>
